import React from 'react'
import PropTypes from 'prop-types'

const Pagination = props => {
    const { inOffset, data, showNext, total, className } = props
    return (
        <div className={className}>
            <div className="hsg-dashboard-pagination-page">
                <span className="hsg-dashboard-pagination-page-on">
                    {inOffset + 1}{'-' + (inOffset + data.length)}
                </span>
                {' of ' + total}
            </div>
            <button onClick={() => showNext('prev')} className={inOffset === 0 ? "hsg-btn-disabled pagination-btn" : "hsg-btn-nxt pagination-btn"}>
                <span aria-hidden="true" data-icon="&#e906;" className="icon-previous"></span>
            </button>&nbsp;
            <button onClick={() => showNext('next')} className={(total - inOffset) <= data.length ? "hsg-btn-disabled pagination-btn" : "hsg-btn-nxt pagination-btn"}>
                <span aria-hidden="true" data-icon="&#e908;" className="icon-next"></span>
            </button>
        </div>
    )
}

export default Pagination

Pagination.propTypes = {
    data: PropTypes.array.isRequired,
    total: PropTypes.number.isRequired,
    className: PropTypes.string.isRequired,
    showNext: PropTypes.func.isRequired
}


// WEBPACK FOOTER //
// ./src/Containers/HSGPagination/HSGPagination.js